// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseButton_close__3N3IO","fix-to-top":"CloseButton_fix-to-top__3aGSE"};